import React from "react";
import { Route, Routes } from "react-router-dom";

import WhatsApp from "./whatsapp";

export default function PrivacyPolicy() {
  return (
    <Routes>
      <Route path="whatsapp" element={<WhatsApp />} />
    </Routes>
  );
}
